import {
  GOOGLE_STORAGE_ENDPOINT as storageURL,
  GOOGLE_STORAGE_PRIVATE_ENDPOINT,
} from '../utils/apiConstants'

const storagePrivateURL = GOOGLE_STORAGE_PRIVATE_ENDPOINT
export const avatarURLParse = (imagePath) => storageURL.concat(imagePath)
export const resourcerPrivateParse = (imagePath) => storagePrivateURL.concat(imagePath)

export const getUrlSearchParams = (str) =>
  new URLSearchParams(str.split('?')[1])

export default avatarURLParse
